/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EcommerceUserApiResponseVo
 */
export interface EcommerceUserApiResponseVo {
    /**
     * 平台API配置ID。
     * @type {number}
     * @memberof EcommerceUserApiResponseVo
     */
    id?: number;
    /**
     * 平台字典ID。
     * @type {number}
     * @memberof EcommerceUserApiResponseVo
     */
    businessPlatformId?: number;
    /**
     * 当前语言平台名称。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    platformName?: string;
    /**
     * 平台侧企业/店铺账号标识。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    externalAccountId?: string;
    /**
     * Key脱敏值。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    credentialKeyMask?: string;
    /**
     * Secret脱敏值。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    credentialSecretMask?: string;
    /**
     * 凭证有效期；为空表示无限期。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    credentialExpireTime?: string;
    /**
     * 凭证是否无限期；与到期时间为空同义。
     * @type {boolean}
     * @memberof EcommerceUserApiResponseVo
     */
    credentialExpireUnlimited?: boolean;
    /**
     * 最近连接状态。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    connectionStatus?: string;
    /**
     * 最近测试连接时间。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    lastTestTime?: string;
    /**
     * 最近失败脱敏原因。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    lastErrorMessage?: string;
    /**
     * 启用状态：0停用、1启用。
     * @type {number}
     * @memberof EcommerceUserApiResponseVo
     */
    enable?: number;
    /**
     * 乐观锁版本。
     * @type {number}
     * @memberof EcommerceUserApiResponseVo
     */
    version?: number;
    /**
     * 创建时间。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    createTime?: string;
    /**
     * 修改时间。
     * @type {string}
     * @memberof EcommerceUserApiResponseVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the EcommerceUserApiResponseVo interface.
 */
export function instanceOfEcommerceUserApiResponseVo(value: object): value is EcommerceUserApiResponseVo {
    return true;
}

export function EcommerceUserApiResponseVoFromJSON(json: any): EcommerceUserApiResponseVo {
    return EcommerceUserApiResponseVoFromJSONTyped(json, false);
}

export function EcommerceUserApiResponseVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcommerceUserApiResponseVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'platformName': json['platformName'] == null ? undefined : json['platformName'],
        'externalAccountId': json['externalAccountId'] == null ? undefined : json['externalAccountId'],
        'credentialKeyMask': json['credentialKeyMask'] == null ? undefined : json['credentialKeyMask'],
        'credentialSecretMask': json['credentialSecretMask'] == null ? undefined : json['credentialSecretMask'],
        'credentialExpireTime': json['credentialExpireTime'] == null ? undefined : json['credentialExpireTime'],
        'credentialExpireUnlimited': json['credentialExpireUnlimited'] == null ? undefined : json['credentialExpireUnlimited'],
        'connectionStatus': json['connectionStatus'] == null ? undefined : json['connectionStatus'],
        'lastTestTime': json['lastTestTime'] == null ? undefined : json['lastTestTime'],
        'lastErrorMessage': json['lastErrorMessage'] == null ? undefined : json['lastErrorMessage'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'version': json['version'] == null ? undefined : json['version'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function EcommerceUserApiResponseVoToJSON(json: any): EcommerceUserApiResponseVo {
    return EcommerceUserApiResponseVoToJSONTyped(json, false);
}

export function EcommerceUserApiResponseVoToJSONTyped(value?: EcommerceUserApiResponseVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'businessPlatformId': value['businessPlatformId'],
        'platformName': value['platformName'],
        'externalAccountId': value['externalAccountId'],
        'credentialKeyMask': value['credentialKeyMask'],
        'credentialSecretMask': value['credentialSecretMask'],
        'credentialExpireTime': value['credentialExpireTime'],
        'credentialExpireUnlimited': value['credentialExpireUnlimited'],
        'connectionStatus': value['connectionStatus'],
        'lastTestTime': value['lastTestTime'],
        'lastErrorMessage': value['lastErrorMessage'],
        'enable': value['enable'],
        'version': value['version'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

